module.exports = __webpack_public_path__ + "img/pjysc.de67bc47.png";